import { useEffect, useState } from "react";

const AuthorizedQrImage = ({ src, accessToken, ...props }) => {
  const [objectUrl, setObjectUrl] = useState("");

  useEffect(() => {
    let active = true;
    let url = "";

    if (!src || !accessToken) {
      setObjectUrl("");
      return () => {};
    }

    fetch(src, {
      headers: { Authorization: `Bearer ${accessToken}` },
      cache: "no-store",
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.blob();
      })
      .then((blob) => {
        if (!active) return;
        url = URL.createObjectURL(blob);
        setObjectUrl(url);
      })
      .catch(() => {
        if (active) setObjectUrl("");
      });

    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [src, accessToken]);

  if (!objectUrl) return null;
  return <img {...props} src={objectUrl} alt={props.alt || "QR"} />;
};

export default AuthorizedQrImage;
